module.exports = __webpack_public_path__ + "img/ba86bc8.jpg";